export default [
	{
		type: 'shield',
		slug: 'wooden-shield',
		targets: [ 'empty' ],
		levels: [
			{ armor: 1, durability: 2 },
			{ armor: 1, durability: 3 },
			{ armor: 2, durability: 1 },
		],
		triggers: [],
		fr: {
			name: "Bouclier en bois",
			description: "-"
		},
		en: {
			name: "Wooden shield",
			description: "-"
		}
	},
	{
		type: 'shield',
		slug: 'iron-shield',
		targets: [ 'empty' ],
		levels: [
			{ armor: 1, durability: 4 },
			{ armor: 2, durability: 2 },
			{ armor: 3, durability: 1 },
		],
		triggers: [],
		fr: {
			name: "Bouclier en fer",
			description: "-"
		},
		en: {
			name: "Iron shield",
			description: "-"
		}
	},
	{
		type: 'shield',
		slug: 'bronze-shield',
		targets: [ 'empty' ],
		levels: [
			{ armor: 1, durability: 1 },
			{ armor: 1, durability: 2 },
			{ armor: 2, durability: 2 },
		],
		triggers: [
			{
				on: 'after-full-block',
				method: 'heal',
				value: 1
			}
		],
		fr: {
			name: "Bouclier en bronze",
			description: "Après un blocage complet, soigne 1 point de vie."
		},
		en: {
			name: "Bronze shield",
			description: "After a complete block, heal 1 health point."
		}
	},
	{
		type: 'shield',
		slug: 'golden-shield',
		targets: [ 'empty' ],
		levels: [
			{ armor: 1, durability: 1 },
			{ armor: 1, durability: 2 },
			{ armor: 2, durability: 2 },
		],
		triggers: [
			{
				on: 'after-full-block',
				method: 'gain_gold',
				value: 1
			}
		],
		fr: {
			name: "Bouclier en or",
			description: "Gagne 1 émeraude après chaque coup bloqué."
		},
		en: {
			name: "Golden shield",
			description: "Gains 1 emerald after each blocked hit."
		}
	},
	{
		type: 'shield',
		slug: 'cursed-shield',
		targets: [ 'empty' ],
		levels: [
			{ armor: 1, durability: 1 },
			{ armor: 1, durability: 2 },
			{ armor: 2, durability: 2 },
		],
		triggers: [
			{
				on: 'after-full-block',
				method: 'give',
				strength: 1
			},
			{
				on: 'after-not-full-block',
				method: 'give',
				poison: 1,
			}
		],
		fr: {
			name: "Bouclier corrompu",
			description: "Après un blocage complet, vous recevez (force 1)[status-strength:1], sinon (poison 1)[status-poison:1]."
		},
		en: {
			name: "Cursed shield",
			description: "After a complete block, you receive (strength 1)[status-strength:1], otherwise (poison 1)[status-poison:1]."
		}
	},
]